import request from '@/api/axios'
import { apiList as api } from './apiList'

// 获取用户空间基本信息
export function getUserSpaceBaseInfo(userId) {
  return request({
    url: api.spaceInfo.getUserSpaceBaseInfo + userId,
    method: 'get',
  })
}

// 设置展示范围
export function settingRadius(userId, radius) {
  return request({
    url: api.spaceInfo.settingRadius + userId + '/' + radius,
    method: 'post',
  })
}

// 获取背景图列表
export function getBackgroundImages() {
  return request({
    url: api.spaceInfo.getBackgroundImages,
    method: 'get',
  })
}

// 设置背景图
export function settingBackgroundImage(userId, backImageId) {
  return request({
    url: api.spaceInfo.settingBackgroundImage + userId + '/' + backImageId,
    method: 'post',
  })
}

// 空间搜索
export function userSpaceSearch(spaceAccount) {
  return request({
    url: api.spaceInfo.userSpaceSearch + spaceAccount,
    method: 'get',
  })
}

// 获取最近访客列表
export function getRecentVisitor(userId) {
  return request({
    url: api.spaceInfo.getRecentVisitor + userId,
    method: 'get',
  })
}

// 获取用户名片信息
export function getCardInfo(userId, query) {
  return request({
    url: api.spaceInfo.getCardInfo + userId,
    method: 'get',
    params: query,
  })
}

// 增加一次访问记录
export function addVisitorLog(visitedId, visitorAvatar) {
  return request({
    url: api.spaceInfo.addVisitorLog + visitedId,
    method: 'post',
    params: visitorAvatar,
  })
}

// 随便逛逛，随机获取一个本机构有内容的userId
export function pokeAround(platform) {
  return request({
    url: api.spaceInfo.pokeAround,
    method: 'get',
    params: platform,
  })
}

// 课堂展示信息分页
export function getClassShow(userId, viewRadius, params) {
  return request({
    url: `${api.spaceInfo.getClassShow}${userId}/${viewRadius}`,
    method: 'get',
    params,
  })
}

// 课堂展示信息详情
export function getShowDetail(userId, lessonId) {
  return request({
    url: `${api.spaceInfo.getShowDetail}${userId}/${lessonId}`,
    method: 'get',
  })
}

//笔记分页
export function getNote(userId, visitorType, params) {
  return request({
    url: `${api.spaceInfo.getNote}${userId}/${visitorType}`,
    method: 'get',
    params,
  })
}

// 学生空间-点赞
export function giveALike(dynamicId, dynamicContentType, opType) {
  return request({
    url: api.spaceActivity.giveALike + dynamicId + '/' + dynamicContentType + '/' + opType, // 点赞
    method: 'post',
  })
}

// 获取活动列分页
export function getActivityList(params) {
  return request({
    url: api.spaceActivity.getActivityList,
    method: 'get',
    params,
  })
}

// 获取活动作品详情
export function getWorkPageDetails(id, params) {
  return request({
    url: api.spaceActivity.getWorkPageDetails + id,
    method: 'get',
    params,
  })
}

//设置公开和隐藏（学生活动）
export function setStuActivity(data) {
  return request({
    url: api.spaceActivity.setStuActivity,
    method: 'post',
    data,
  })
}
